

















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Intensitas extends Vue {
  @Prop() setIntensitas: string;
  @Prop() setLabel!: string;
  // intensitas = null;
  label = "";
  placeholder = this.setLabel;
  validasi = [(v) => this.cek()];

  // @Watch("intensitas")
  // changeIntensitas(val) {
  //   this.$emit("intensitas", val);
  // }

  @Watch("setIntensitas")
  valIntensitas(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("intensitas", val);
    this.setIntensitas = val;
  }
  cek() {
    if (this.setIntensitas) {
      if (isNaN(Number(this.setIntensitas)))
        this.setIntensitas = this.setIntensitas.substring(
          0,
          this.setIntensitas.length - 1
        );
    }
    return true;
  }
}
